<template>
  <v-app>
    <v-main class="landingpage">
      <section>
        <div class="globe-header">
          <v-layout
            column
            align-center
            justify-center
            class="white--text bg-gradient fill-height overflow-hidden"
          >
            <!-- <iframe src="/globe/index.html" class="iframe-globe" title="Self Biography Globe" frameborder="0" allowtransparency="true"></iframe> -->

            <video
              width="100%"
              height="100%"
              muted
              autoplay
              loop
              playsinline
            >
              <source
                :src="require('@/assets/images/pages/landingpage/globe.mp4')"
                type="video/mp4"
              >
              Your browser does not support the video tag.
            </video>

            <div class="globe-text">
              <div class="wrapper-logo">
                <img :src="require('@/assets/images/logos/selfbio-logo-6.png')" />
                <h2
                  class="app-title text--primary"
                  style="color: #fff !important"
                >
                  <span style="color: #9155fd;">SELF</span>BIOGRAPHY
                </h2>
              </div>
              <h1 class="white--text mb-2 display-1 text-xs-center txt-title-header">
                Record Your Life. Tell Your Story. Leave Your Mark on the World.
              </h1>
              <div class="white--text subheading mb-3 text-xs-center txt-subtitle">
                Everyone has a story worth preserving, for themselves and future generations.
              </div>
            </div>
          </v-layout>
          <div class="landing-v4-hero-actions">
            <div class="white--text subheading mb-3 text-xs-center txt-why-not">
              Your life is the puzzle.
            </div>
            <div class="landing-v4-button-row">
              <v-btn
                class="blue lighten-2 mt-5"
                dark
                large
                href="/auth"
              >
                JOIN FREE
              </v-btn>
              <v-btn
                class="blue lighten-2 mt-5"
                dark
                large
                href="/pages/pricing#choose-plan"
              >
                SUBSCRIBE
              </v-btn>
              <v-btn
                class="blue lighten-2 mt-5"
                dark
                large
                href="/pages/affiliate-program"
              >
                EARN
              </v-btn>
            </div>
          </div>
        </div>
      </section>
      <section>
        <v-layout
          column
          wrap
          class="mt-10"
          align-center
        >
          <v-flex xs12>
            <v-container grid-list-xl>
              <v-layout
                row
                wrap
                align-center
              >
                <div class="section">
                  <div class="container">
                    <div class="perspective-phone">
                      <h2 class="headline text-center">
                        Anytime, anywhere. Your life, memories, and life’s work in one place.
                      </h2>
                      <img
                        :src="require('@/assets/images/pages/landing-laptop.webp')"
                        alt="Perspective computer"
                        style="position:relative;top:-38px;"
                      >
                    </div>
                    <div
                      class="row"
                      style="position:relative;top:-60px;"
                    >
                      <div class="col-12 col-lg-4">
                        <div class="card features">
                          <div class="card-body">
                            <div class="media">
                              <span class="ti-face-smile gradient-fill ti-3x mr-3"></span>
                              <div class="media-body">
                                <h4 class="card-title">
                                  Simple and Easy to Use
                                </h4>
                                <p class="card-text mt-2">
                                  Record your life one memory at a time.<br />
                                  Add photographs, videos, stories, and documents from your phone or computer.<br />
                                  Self Biography optimizes your images and videos so you can focus on the memory.
                                </p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="col-12 col-lg-4">
                        <div class="card features">
                          <div class="card-body">
                            <div class="media">
                              <span class="ti-settings gradient-fill ti-3x mr-3"></span>
                              <div class="media-body">
                                <h4 class="card-title">
                                  Customizable
                                </h4>
                                <p class="card-text mt-2">
                                  Use the standard categories, edit them, or create your own.
                                  Organize memories around the people, places, and experiences that matter to you.<br />
                                  Edit and expand your story at any time. You decide what stays private and what becomes public.
                                </p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="col-12 col-lg-4">
                        <div class="card features">
                          <div class="card-body">
                            <div class="media">
                              <span class="ti-lock gradient-fill ti-3x mr-3"></span>
                              <div class="media-body">
                                <h4 class="card-title">
                                  Private and Secure
                                </h4>
                                <p class="card-text mt-2">
                                  Your private archive and your public biography are different things. You are always the gatekeeper.<br />
                                  Keep memories private or publish only what you choose, using record and category privacy controls.
                                </p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </v-layout>
            </v-container>
          </v-flex>
        </v-layout>
      </section>

      <section
        class="section-carrousel landing-v4-stories"
        aria-label="Discover Self Biography"
      >
        <v-carousel
          :cycle="!expandedStory"
          :interval="$vuetify.breakpoint.smAndDown ? 90000 : 60000"
          height="auto"
        >
          <v-carousel-item
            v-for="story in stories"
            :key="story.id"
            :src="require(`@/assets/images/pages/landingpage/${story.image}`)"
            color="#000000"
          >
            <div class="landing-v4-story-copy">
              <h5 class="white--text mb-2 display-1 text-xs-center">
                {{ story.title }}
              </h5>
              <p
                v-for="paragraph in story.paragraphs"
                :key="paragraph"
              >
                {{ paragraph }}
              </p>
              <details
                v-if="story.more"
                @toggle="expandedStory = $event.target.open ? story.id : null"
              >
                <summary>{{ story.more.title }}</summary>
                <p
                  v-for="paragraph in story.more.paragraphs"
                  :key="paragraph"
                >
                  {{ paragraph }}
                </p>
              </details>
              <a
                v-if="story.link"
                :href="story.link.to"
              >
                {{ story.link.label }}
              </a>
            </div>
          </v-carousel-item>
        </v-carousel>
      </section>
      <section class="landingpage">
        <v-container grid-list-md>
          <h2 class="headline text-center ma-10">
            Everything in one place in chronological order
          </h2>
          <v-layout
            row
            wrap
          >
            <v-flex>
              <v-card class="elevation-0 transparent">
                <v-card-text>
                  <v-timeline
                    align-top
                    :dense="$vuetify.breakpoint.smAndDown"
                  >
                    <v-timeline-item
                      v-for="(item, i) in items"
                      :key="i"
                      :color="item.color"
                      :icon="item.icon"
                      fill-dot
                    >
                      <v-card
                        :color="item.color"
                        dark
                      >
                        <v-card-title class="text-h6">
                          {{ item.title }}
                        </v-card-title>
                        <v-card-text class="white text--primary">
                          <p class="pt-5">
                            {{ item.text }}
                          </p>
                        </v-card-text>
                      </v-card>
                    </v-timeline-item>
                  </v-timeline>

                  <h2
                    class="headline text-center pt-15"
                    style="color: #633991 !important"
                  >
                    Self Biography is not Facebook.
                  </h2>
                  <div class="subheading mb-3 text-xs-center txt-subtitle text-justify">
                    Self Biography brings people together through their shared memories rather than keeping them apart by their opinions. Preserve the stories, knowledge, accomplishments, and experiences that make up a life. Your private archive and your public biography are different things. You decide which pieces of your story to share.
                  </div>
                </v-card-text>
              </v-card>
            </v-flex>
          </v-layout>
        </v-container>
      </section>
      <section
        id="life-puzzle"
        class="landingpage landing-v4-puzzle py-10"
        aria-labelledby="landing-v4-puzzle-title"
      >
        <v-container grid-list-md>
          <v-row align="start">
            <v-col
              cols="12"
              md="6"
            >
              <div
                class="landing-v4-puzzle-pictures"
                aria-hidden="true"
              >
                <v-img
                  v-for="picture in puzzlePictures"
                  :key="picture.label"
                  :src="require(`@/assets/images/pages/landingpage/${picture.image}`)"
                  :aspect-ratio="1"
                  alt=""
                >
                  <span class="landing-v4-puzzle-caption">{{ picture.label }}</span>
                </v-img>
              </div>
            </v-col>
            <v-col
              cols="12"
              md="6"
            >
              <v-card class="elevation-0 transparent landing-v4-puzzle-copy">
                <v-card-text>
                  <p class="primary--text text-uppercase font-weight-medium">
                    The Life Puzzle
                  </p>
                  <h2
                    id="landing-v4-puzzle-title"
                    class="headline primary--text mb-6"
                  >
                    Every memory is a piece.<br />Your life is the puzzle.
                  </h2>
                  <p class="txt-subtitle">
                    Start anywhere: in childhood, yesterday, your travels, or your career. Connect photographs, dates, people, and places. Ask others about missing pieces and watch your biography take shape.
                  </p>
                  <p class="txt-subtitle font-weight-medium">
                    There is no predetermined picture on the box. The picture is you.
                  </p>
                  <details class="landing-v4-puzzle-details">
                    <summary class="primary--text font-weight-medium">
                      Discover the game
                    </summary>
                    <v-chip
                      small
                      outlined
                      color="primary"
                      class="my-4"
                    >
                      Coming soon
                    </v-chip>
                    <p class="caption font-weight-medium">
                      Game experience in development
                    </p>
                    <h3 class="text-h6 mt-6 mb-2">
                      The Life Puzzle Game
                    </h3>
                    <p class="txt-subtitle">
                      Turn memories into Memory Bits, the individual tiles of your Life Puzzle. Each tile can hold photographs, stories, videos, dates, places, people, and shared experiences. The proposed game experience builds on these pieces to reveal the bigger picture of your life.
                    </p>
                    <h3 class="text-h6 mt-6 mb-2">
                      Easy game onboarding
                    </h3>
                    <p class="txt-subtitle">
                      Start anywhere. Begin with one memory or a collection. Build backward, forward, or anywhere in between. The vision is to help you match people, places, dates, and historical events, discover missing pieces, and invite others to help complete your puzzle.
                    </p>
                    <h3 class="text-h6 mt-6 mb-2">
                      Rewards &amp; SB Tokens
                    </h3>
                    <p class="txt-subtitle">
                      Proposed internal game tokens would reward completing Memory Bits and making meaningful connections. These rewards are a future concept, separate from purchased AI credits and real-money affiliate commissions.
                    </p>
                  </details>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </v-container>
      </section>
      <section
        class="landingpage landing-v4-planned"
        aria-labelledby="landing-v4-planned-title"
      >
        <v-container grid-list-md>
          <p class="primary--text text-center text-uppercase font-weight-medium mt-10">
            Coming soon &amp; future development
          </p>
          <h2
            id="landing-v4-planned-title"
            class="headline primary--text text-center ma-10"
          >
            More chapters are still to come.
          </h2>
          <v-card class="elevation-0 transparent">
            <v-card-text>
              <p class="subheading mb-3 txt-subtitle">
                The following ideas are in development or part of our future vision. They are separate from the features and subscription benefits available today.
              </p>
              <v-timeline
                align-top
                :dense="$vuetify.breakpoint.smAndDown"
              >
                <v-timeline-item
                  v-for="feature in plannedItems"
                  :key="feature.title"
                  :icon="feature.icon"
                  fill-dot
                >
                  <v-card dark>
                    <v-card-title class="text-h6 px-4">
                      {{ feature.title }}
                    </v-card-title>
                    <div class="px-5 pb-4">
                      <v-chip
                        small
                        outlined
                        dark
                      >
                        Coming soon
                      </v-chip>
                    </div>
                    <v-card-text
                      class="text--primary"
                      :class="{ white: !$vuetify.theme.dark }"
                    >
                      <p class="pt-5">
                        {{ feature.text }}
                      </p>
                    </v-card-text>
                  </v-card>
                </v-timeline-item>
              </v-timeline>
            </v-card-text>
          </v-card>
        </v-container>
      </section>
      <section class="section-carrousel">
        <v-carousel
          cycle
          :height="imgHeight"
        >
          <v-carousel-item
            v-for="([slide, text], i) in slides"
            :key="i"
            :src="require(`@/assets/images/pages/landingpage/${ slide }`)"
            color="#000000"
          >
            <h5 class="white--text mb-2 display-1 text-xs-center">
              {{ text }}
            </h5>
          </v-carousel-item>
        </v-carousel>
      </section>
    </v-main>
  </v-app>
</template>

<script>
import { mdiStar } from '@mdi/js'
import content from '@/content/landingPageContentV3.json'

export default {
  name: 'LandingPageV4',
  components: {},
  data() {
    return {
      stories: content.stories,
      expandedStory: null,
      puzzlePictures: [
        { image: '2.webp', label: 'Memories' },
        { image: '10.webp', label: 'Life’s work' },
        { image: '1.webp', label: 'Connections' },
        { image: '15.webp', label: 'Experiences' },
      ],
      videoOptions: {
        autoplay: false,
        controls: true,
        sources: [
          {
            src:
              'https://www.youtube.com/embed/IMRJhk-4ik0',
            type: 'youtube',
          },
        ],
      },
      slides: [
        ['2.webp', 'My Memories'],
        ['4.webp', 'My Places'],
        ['8.webp', 'My Diary'],
        ['9.webp', 'My Story'],
        ['7.webp', 'My Things'],
        ['10.webp', 'My Life’s Work'],
        ['11.webp', 'My Food'],
        ['12.webp', 'My Pets'],
        ['13.webp', 'My Thoughts'],
        ['14.webp', 'My Beliefs'],
        ['15.webp', 'My Travels'],
      ],
      items: content.features.map(feature => ({ ...feature, icon: mdiStar })),
      plannedItems: content.planned.map(feature => ({ ...feature, icon: mdiStar })),
    }
  },

  computed: {
    imgHeight() {
      return window.innerHeight * 0.70
    },
  },
  methods: {
  },
}
</script>

<style scoped>
.landing-v4-puzzle-pictures {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 12px;
  max-width: 550px;
  margin: 0 auto;
}

.landing-v4-puzzle-pictures .v-image {
  border-radius: 6px;
}

.landing-v4-puzzle-caption {
  position: absolute;
  right: 0;
  bottom: 0;
  left: 0;
  padding: 24px 12px 8px;
  background: linear-gradient(transparent, rgba(0, 0, 0, 0.8));
  color: #fff;
  font-size: 13px;
}

.landing-v4-puzzle-copy p {
  line-height: 1.7;
}

.landing-v4-puzzle-details summary {
  padding: 12px 0;
  cursor: pointer;
}

.landing-v4-stories ::v-deep .v-responsive__sizer {
  padding-bottom: 0 !important;
}

.landing-v4-story-copy {
  position: relative;
  z-index: 2;
  display: flex;
  flex-direction: column;
  justify-content: center;
  min-height: 651px;
  max-width: 1080px;
  margin: 0 auto;
  padding: 64px 72px 88px;
  color: #fff;
  font-size: 18px;
  line-height: 1.7;
  text-shadow: 0 1px 6px #000;
}

.landing-v4-story-copy h5 {
  position: static;
  width: auto;
  margin-bottom: 24px !important;
  transform: none;
}

.landing-v4-story-copy a {
  align-self: flex-start;
  color: #fff;
  text-decoration: underline;
  text-underline-offset: 4px;
}

.landing-v4-story-copy details {
  margin-bottom: 16px;
}

.landing-v4-story-copy summary {
  cursor: pointer;
  font-weight: 600;
}

.landing-v4-story-copy details[open] summary {
  margin-bottom: 16px;
}

@media (max-width: 600px) {
  .landingpage .v-timeline--dense:not(.v-timeline--reverse)::before {
    left: 32px;
  }

  .v-timeline--dense ::v-deep .v-timeline-item__divider {
    min-width: 64px;
  }

  .v-timeline--dense ::v-deep .v-timeline-item__body {
    max-width: calc(100% - 64px);
  }

  .landing-v4-story-copy {
    padding: 48px 48px 80px;
    font-size: 16px;
  }

  .landing-v4-story-copy h5 {
    font-size: 1.75rem !important;
  }
}

.landing-v4-hero-actions {
  position: absolute;
  bottom: 50px;
  z-index: 1;
  left: 50%;
  width: calc(100% - 32px);
  transform: translateX(-50%);
}

.landing-v4-button-row {
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  gap: 8px;
}

@media (max-width: 400px) {
  .landing-v4-button-row .v-btn {
    min-width: 0;
    padding-right: 10px;
    padding-left: 10px;
  }
}
</style>
